import { Component } from '@angular/core';

@Component({
  selector: 'app-brand-symbol',
  standalone: true,
  host: { 'aria-hidden': 'true' },
  template: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 224 288" fill="none" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M64 0H128V64H192V128H128V192H64V128H0V64H64Z" />
      <path fill="var(--brand-logo-green)" d="M64 192H128V200C128 213.255 138.745 224 152 224H224V288H152C103.399 288 64 248.601 64 200Z" />
    </svg>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; color: inherit; }
    svg { display: block; width: 100%; height: 100%; }
  `],
})
export class AppBrandSymbolComponent {}
